import React from "react";
import LegalPage from "../../components/LegalPage";
import { getViewfaqList } from "../../services/FaqService";
import useSeo from "../../utils/useSeo";

// The FAQ service returns items as { question, answer, ... }. The shared
// LegalPage component expects { title, description, sequence }, so adapt here.
const faqFetcher = () =>
  getViewfaqList({ limit: 500, page: 1, search: "", is_reload: false }).then(
    (response) => {
      const raw = Array.isArray(response?.data?.data) ? response.data.data : [];
      const mapped = raw.map((item, idx) => ({
        sequence: idx + 1,
        title: item.question,
        description: item.answer,
        updated_at: item.updated_at,
        created_at: item.created_at,
      }));
      return { ...response, data: { ...response.data, data: mapped } };
    }
  );

const FAQ = () => {
  useSeo({
    title: "Perguntas Frequentes (FAQ)",
    description:
      "Respostas às perguntas mais comuns sobre a TP Software — funcionalidades, subscrição, integração Moloni, etiquetas térmicas, despoluição LER e mais.",
    keywords: "FAQ, perguntas frequentes, ajuda, suporte, TP Software, como funciona",
    path: "/faq",
  });

  return (
    <LegalPage
      eyebrow="Centro de Ajuda"
      title="Perguntas Frequentes"
      subtitle="Encontre rapidamente as respostas às dúvidas mais comuns sobre a plataforma. Não encontrou o que procura? Fale connosco."
      fetcher={faqFetcher}
      emptyMessage="Ainda não existem perguntas publicadas."
    />
  );
};

export default FAQ;
